import React from "react";
import {useIntl} from "react-intl";

import {useSnackbar} from "notistack";

const LONG_HIDE_DURATION = 3000;
const WAITING_HIDE_DURATION = 7000;
const SHORT_HIDE_DURATION = 1000;

// add action to an individual snackbar

const useToast = () => {
  const {enqueueSnackbar, closeSnackbar} = useSnackbar();
  const {formatMessage} = useIntl();

  const action = (snackbarId) => (
    <span
      onClick={() => {
        closeSnackbar(snackbarId);
      }}
      style={{cursor: "pointer", color: "white"}}
    >
      CLOSE
    </span>
  );

  const toastSuccess = (message) => {
    enqueueSnackbar(message, {
      variant: "success",
      autoHideDuration: SHORT_HIDE_DURATION
    });
  };

  const toastFail = (message) => {
    enqueueSnackbar(message ?? "Something went wrong!", {
      variant: "error",
      autoHideDuration: LONG_HIDE_DURATION
    });
  };

  const toastInfoAction = (message) => {
    enqueueSnackbar(message, {
      variant: "info",
      autoHideDuration: WAITING_HIDE_DURATION,
      action
    });
  };

  const toastInfo = (message) => {
    enqueueSnackbar(message, {
      variant: "info",
      autoHideDuration: LONG_HIDE_DURATION,
      preventDuplicate: true
    });
  };

  const toastErrorMessage = (error) => {
    const message = error.response?.data?.message ?? error.message;
    toastFail(message);
  };

  const toastUpdateSuccess = () => {
    const message = formatMessage({
      id: "common-toast-update-success",
      defaultMessage: "Update successfully!"
    });
    enqueueSnackbar(message, {
      variant: "success",
      autoHideDuration: SHORT_HIDE_DURATION
    });
  };

  const toastUpdateFailed = () => {
    const message = formatMessage({
      id: "common-toast-update-failed",
      defaultMessage: "Update failed!"
    });
    enqueueSnackbar(message, {
      variant: "error",
      autoHideDuration: SHORT_HIDE_DURATION
    });
  };

  return {
    toastSuccess,
    toastFail,
    toastInfo,
    toastErrorMessage,
    toastUpdateSuccess,
    toastUpdateFailed,
    toastInfoAction
  };
};

export default useToast;
